var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -4370)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 4370)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.622 4385.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.51,349.3v4.2h12.817v-4.21l4.315-4.315-1.127-3.455-19.895.453,1.083,5.164",
    transform: "translate(-106.529 -317.522)",
    fill: "#1db7c6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.518 22.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.6,375.037l-3.413,3.594-3.173-3.212-3.173,3.212-3.413-3.594",
    transform: "translate(-160.146 -371.682)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.436,341.977h1.086v11.948h-1.086Z",
    transform: "translate(-240.107 -340.945)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.187,327.289s-.784,4.094.3,5.182c0,0,.554-2.789,1.1-3.331s-1.4-1.851-1.4-1.851",
    transform: "translate(-129.914 -327.289)",
    fill: "#1487eb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.359,205.513h.015a2.387,2.387,0,0,0,0-4.774H68.419a2.387,2.387,0,0,0,0,4.774h.015",
    transform: "translate(-66.004 -186.633)",
    fill: "#f1b986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.272,105.379a107.657,107.657,0,0,0-20.826,0,73.83,73.83,0,0,0-.476,12.949,6.109,6.109,0,0,0,5.818,5.791q5.071.239,10.142,0a6.109,6.109,0,0,0,5.818-5.791A73.836,73.836,0,0,0,121.272,105.379Z",
    transform: "translate(-97.466 -97.505)",
    fill: "#ffd5b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,301.8a2.922,2.922,0,0,1-2.628-1.662.606.606,0,1,1,1.1-.52,1.7,1.7,0,0,0,3.065,0,.606.606,0,1,1,1.1.52A2.923,2.923,0,0,1,220.66,301.8Z",
    transform: "translate(-207.267 -278.243)",
    fill: "#e1756a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.936,14.107c-4.892,0-12.407-3.168-15.629-4.636-.972-.443-1.553-.732-1.553-.732s-1.866,4.768-4.67,5.368h-.051a2.371,2.371,0,0,0-1.367.43C65.74,7.873,64.7,3.544,67.04,2.246a3.281,3.281,0,0,1,3.939.3A25.47,25.47,0,0,1,76.548.56c3.837-.892,8.927-1.094,12.83,2.291,4.1,3.555,2.991,8.26.558,11.256Z",
    transform: "translate(-65.617 0)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.307,16.884c-.972-.443-1.553-.732-1.553-.732s-1.866,4.768-4.67,5.368h-.051a2.37,2.37,0,0,0-1.367.43c-.925-6.664-1.964-10.993.374-12.291a3.281,3.281,0,0,1,3.939.3,25.47,25.47,0,0,1,5.569-1.988C72.7,8.908,72.513,14.527,74.307,16.884Z",
    transform: "translate(-65.617 -7.413)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.492,313.634a7.213,7.213,0,0,1-2.124,1.437,2.2,2.2,0,0,1-1.2.152c-4.117-.578-3.611-7.149-3.611-10.978,0-.979,3.793,1.4,3.793,1.4s-.784,4.094.3,5.182Z",
    transform: "translate(-78.561 -282.646)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.368,277.111a2.2,2.2,0,0,1-1.2.152c-4.117-.578-3.611-7.149-3.611-10.978a5.029,5.029,0,0,1,.655-2.505l2.667-.6a8.73,8.73,0,0,0-2.094,5.489C80.787,271.919,82.064,276.417,84.368,277.111Z",
    transform: "translate(-78.561 -244.686)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.834,230.709l-.223,6.787-2.34-.864-1.453-.536a5.362,5.362,0,0,1,1.939-4.068h0A7.726,7.726,0,0,1,83.834,230.709Z",
    transform: "translate(-78.82 -214.497)",
    fill: "#f1b986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.257,299.815c-1.445.289-3.323-1.589-3.323-1.589l2.836-2.807c1.089-1.088.3-5.182.3-5.182s.231-.318.579-.74c1.062-1.288,3.215-3.543,3.215-.66C340.868,292.666,341.373,299.237,337.257,299.815Z",
    transform: "translate(-315.079 -267.238)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.285,322.683c1.089-1.088.3-5.182.3-5.182s.231-.318.579-.74l.8.233s.171,5.351-1.679,5.689Z",
    transform: "translate(-352.594 -294.502)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.456,236.1l-2.419.893-1.375.507-.223-6.787a7.574,7.574,0,0,1,1.714,1.016l.016.013A5.5,5.5,0,0,1,379.456,236.1Z",
    transform: "translate(-353.668 -214.497)",
    fill: "#f1b986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.037,236.989l-1.375.507-.223-6.787a7.574,7.574,0,0,1,1.713,1.016l.016.013A6.765,6.765,0,0,0,377.037,236.989Z",
    transform: "translate(-353.667 -214.497)",
    fill: "#f1b986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.638,247.519H217.9v3.027h-6.264Z",
    transform: "translate(-201.377 -230.125)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.684,199.793c0-4.626,3.327-6.863,5.038-6.863a3.1,3.1,0,0,1,3.1,3.1v3.764Z",
    transform: "translate(-116.814 -179.373)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.068,
    cy: 4.068,
    rx: 4.068,
    ry: 4.068,
    transform: "translate(3.87 16.352)",
    fill: "#0b1519"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.027,
    cy: 3.027,
    rx: 3.027,
    ry: 3.027,
    transform: "translate(4.911 17.394)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.752,250.548a3.027,3.027,0,0,1-3.62,2.968,3.027,3.027,0,0,0,0-5.936,3.028,3.028,0,0,1,3.62,2.968Z",
    transform: "translate(-162.788 -230.127)",
    fill: "#e4f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.56,283.429a3.027,3.027,0,1,1-6-.542,3.027,3.027,0,0,0,5.956,0,3.039,3.039,0,0,1,.049.542Z",
    transform: "translate(-130.596 -263.008)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.08,199.793c0-4.626-3.327-6.863-5.038-6.863a3.1,3.1,0,0,0-3.1,3.1v3.764Z",
    transform: "translate(-261.163 -179.373)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.068,
    cy: 4.068,
    rx: 4.068,
    ry: 4.068,
    transform: "translate(14.78 16.352)",
    fill: "#0b1519"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.027,
    cy: 3.027,
    rx: 3.027,
    ry: 3.027,
    transform: "translate(15.822 17.394)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.011,250.548a3.027,3.027,0,0,1-3.62,2.968,3.027,3.027,0,0,0,0-5.936,3.028,3.028,0,0,1,3.62,2.968Z",
    transform: "translate(-307.136 -230.127)",
    fill: "#e4f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.819,283.429a3.027,3.027,0,1,1-6-.542,3.027,3.027,0,0,0,5.956,0A3.037,3.037,0,0,1,296.819,283.429Z",
    transform: "translate(-274.944 -263.008)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.271,254.084l-1.453-.536a5.362,5.362,0,0,1,1.939-4.068S82.741,252.615,81.271,254.084Z",
    transform: "translate(-78.82 -231.949)",
    fill: "#f1b986"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby10);
export default __webpack_public_path__ + "static/media/baby10.07c826d69304d208227c1741742482e7.svg";
export { ForwardRef as ReactComponent };